
import "./subscription.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useEffect } from "react";

/* imagens */
import whatsapp from "../../assets/whats_icon.png";
import web from "../../assets/web_icon.png";

/* navegação */
import { Link, useNavigate } from "react-router-dom";

export default function Subscription() {

    useEffect(() => { window.scrollTo(0, 0); }, []);

    const navigate = useNavigate();

    function cadastro() {
        navigate("/register");
    }


    return(
        <div className="context">
                    
            <Header access={0}></Header>
            
            <div className="content">
                <div className="ft_topico">Conheça nossos planos</div>
                <div className="ft_descricao">Confira abaixo todos os nossos planos, escolha em qual ramo se enquadra as suas atividades.</div>
                <div className="ft_descricao">Nossos agentes vão além da prestação de informações, eles podem marcar e remarcar compromissos de acordo com a sua disponibilidade de agenda. Também, coletamos todas as informações do atendimento, para que futuramente você possa fazer a gestão de seus clientes de forma muito mais eficiente.</div>
                <div className="space"></div>

                <div className="subscription_box">
                    <div className="subscription_box_title">
                        <span className="subscription_box_title_text">Plano para</span>
                        <span className="subscription_box_title_item">Médicos</span>
                        <span className="subscription_box_title_space"></span>
                        <span className="subscription_box_title_include">1 linha exclusiva</span>
                        <span className="subscription_box_title_include">1 agenda exclusiva</span>
                        <span className="subscription_box_title_include">1.000 créditos para uso do agente por mês</span>
                    </div>
                    <div className="subscription_box_plan" onClick={cadastro}>
                        <div className="subscription_box_plan_item">
                            <span className="subscription_box_plan_title">FUNÇÕES DO AGENTE:</span>
                            
                            <span className="subscription_box_plan_list">Prestar atendimento 24 horas por dia e 7 dias na semana;</span>
                            <span className="subscription_box_plan_list">Atender de forma fluída, amigável e objetiva;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre o local de atendimento, endereço, redes sociais e etc;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre o médico, especialidades e valor de consulta;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre convênios;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre procedimentos e seus respectivos valores;</span>
                            <span className="subscription_box_plan_list">Agendar, reagendar e cancelar: consultas, procedimentos e retornos de acordo com a disponibilidade de agenda do médico.</span>

                            <span className="subscription_box_plan_title">OPÇÕES DE PLANOS:</span>
                            <div className="subscription_box_canais">
                                <div className="subscription_box_canais_item">
                                    <span className="subscription_box_plan_canal">Canal Whatsapp</span>
                                    <img className="subscription_image1" src={whatsapp}></img>
                                    <span className="subscription_box_plan_price_cifra">R$</span>
                                    <span className="subscription_box_plan_price">169,90</span>
                                    <span className="subscription_box_plan_mensalidade">mensalidade</span>
                                </div>
                                <div className="subscription_box_canais_item">
                                    <span className="subscription_box_plan_canal">Multi Canal (+Web)</span>
                                    <div className="subscription_box_canais_item_imagens">
                                        <img className="subscription_image1" src={whatsapp}></img>
                                        <span className="subscription_mais">+</span>
                                        <img className="subscription_image1" src={web}></img>
                                    </div>
                                    <span className="subscription_box_plan_price_cifra">R$</span>
                                    <span className="subscription_box_plan_price">189,90</span>
                                    <span className="subscription_box_plan_mensalidade">mensalidade</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            
            </div>

            <div className="space_form"></div>

             <div className="subscription_button_box">
                <div className="subscription_button_boxA"></div>
                <div className="subscription_button_boxB" onClick={cadastro}>TESTE GRATUITAMENTE POR 7 DIAS</div>
                <div className="subscription_button_boxC"></div>
            </div>

            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>
            
            <Footer access={0}></Footer>

        </div>
    )
}